import DiagnosisButton from './components/DiagnosisButton/DiagnosisButton';
import OrganReviewButton from './components/OrganReviewButton';

export default function getToolbarModule() {
  return [
    {
      name: 'sycai.diagnosisButton',
      defaultComponent: DiagnosisButton,
    },
    {
      name: 'sycai.organReviewButton',
      defaultComponent: OrganReviewButton,
    },
  ];
}
